// extracted by mini-css-extract-plugin
module.exports = {"container":"OrderAddon_container__b2j3k","categoryName":"OrderAddon_categoryName__o7p_G","name":"OrderAddon_name__ztuyx","categoryQuantity":"OrderAddon_categoryQuantity__8kbg2"};